import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-435bbc73"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "me-4" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_7 = { class: "svg-icon svg-icon-2" }
const _hoisted_8 = { class: "card-body pt-0 compact-table" }
const _hoisted_9 = ["title"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PurchaseLogsAdvancedSearch = _resolveComponent("PurchaseLogsAdvancedSearch")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_ctx.can('read', 'payments'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_PurchaseLogsAdvancedSearch, {
                onTypeSelected: _ctx.onTypeChange,
                onReset: _ctx.onReset
              }, null, 8, ["onTypeSelected", "onReset"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.can('create', 'payments'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo('subscriptions-creating')))
                  }, [
                    _createElementVNode("span", _hoisted_7, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/ecommerce/gift.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.translate('giftSubscription')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Datatable, {
            "table-data": _ctx.tableData,
            "table-header": _ctx.tableHeader,
            loading: _ctx.loading,
            "rows-per-page": 10,
            total: _ctx.totalItems,
            "enable-items-per-page-dropdown": false,
            onCurrentChange: _ctx.pageChanged
          }, {
            "cell-id": _withCtx(({ row: purchase }) => [
              _createTextVNode(_toDisplayString(purchase.id), 1)
            ]),
            "cell-purchaseDateTime": _withCtx(({ row: purchase }) => [
              _createTextVNode(_toDisplayString(purchase.purchaseDateTime), 1)
            ]),
            "cell-service": _withCtx(({ row: purchase }) => [
              _createTextVNode(_toDisplayString(purchase?.service ?? ' - '), 1)
            ]),
            "cell-packageName": _withCtx(({ row: purchase }) => [
              _createTextVNode(_toDisplayString(purchase?.packageName ?? ' - '), 1)
            ]),
            "cell-customerName": _withCtx(({ row: purchase }) => [
              _createTextVNode(_toDisplayString(purchase.customerName ?? ' - '), 1)
            ]),
            "cell-amount": _withCtx(({ row: purchase }) => [
              _createTextVNode(_toDisplayString(purchase.amount ?? ' - '), 1)
            ]),
            "cell-phoneNumber": _withCtx(({ row: purchase }) => [
              _createElementVNode("span", {
                class: "truncatable-cell",
                title: purchase?.phoneNumber
              }, _toDisplayString(purchase.phoneNumber ?? ' - '), 9, _hoisted_9)
            ]),
            "cell-accountType": _withCtx(({ row: purchase }) => [
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.accountTypeClass(purchase.accountType))
              }, _toDisplayString(purchase.accountType ?? ' - '), 3)
            ]),
            "cell-status": _withCtx(({ row: purchase }) => [
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.statusClass(purchase.status))
              }, _toDisplayString(purchase.status), 3)
            ]),
            "cell-isActive": _withCtx(({ row: purchase }) => [
              _createElementVNode("span", {
                class: _normalizeClass(
              purchase.isActive
                ? 'badge badge-light-success'
                : 'badge badge-light-danger'
            )
              }, _toDisplayString(purchase.isActive ? _ctx.translate('active') : _ctx.translate('inactive')), 3)
            ]),
            "cell-actions": _withCtx(({ row: purchase }) => [
              _createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                onClick: _withModifiers(($event: any) => (_ctx.overviewPurchase(purchase.id || purchase.id)), ["prevent"])
              }, [
                _createElementVNode("span", _hoisted_11, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                ])
              ], 8, _hoisted_10)
            ]),
            _: 1
          }, 8, ["table-data", "table-header", "loading", "total", "onCurrentChange"])
        ])
      ]))
    : _createCommentVNode("", true)
}